export const ADD_SNACKBAR_NOTIFICATION = 'notifications/ADD_SNACKBAR_NOTIFICATION';
export const CLOSE_SNACKBAR_NOTIFICATION = 'notifications/CLOSE_SNACKBAR_NOTIFICATION';